import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setBanId, setBanError, selectDeviceById } from "../../../store/mine_craft/devicesSlice";
import { fetchDevice, blockDevice, banIpDevice } from "../../../actions/mine_craft/devicesActions";
import { fetchBannedIps } from "../../../actions/mine_craft/bannedIpsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import { CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import { Button as ButtonAnt, Form, Input, Divider, Tag, message } from "antd";
import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";
import FormBlock from "./_partials/_FormBlock";
import Meta from "./_partials/_Meta";
import RowInfo from "../../../componets/RowInfo";
import { formattedDate } from "../../../helpers/DateHelpers";
import { Button } from "../../../componets/Buttons";

const Block = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.mineCraft.devices.banId);
  const error   = useAppSelector(state => state.mineCraft.devices.banError);
  const device  = useAppSelector(state => selectDeviceById(state, id));
  const [banIpForm] = Form.useForm();
  const [banIpLoading, setBanIpLoading] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(fetchDevice(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    banIpForm.resetFields();
  }, [id, banIpForm]);

  function onCloseError() {
    dispatch(setBanError(null));
  }

  function onClose() {
    dispatch(setBanId(null));
  }

  function onClickUnBlock(type: 'ban' | 'mute') {
    handleSave({ type: type, period: 0, duration: 'days' }).catch(console.error);
  }

  function onFinish(data: any) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: any) {
    const formData = objToFormData(data);
    dispatch(blockDevice({ id, data: formData }));
  }

  async function onBanIp(values: any) {
    setBanIpLoading(true);
    const resultAction = await dispatch(banIpDevice({ id, data: values }));
    setBanIpLoading(false);

    if (banIpDevice.fulfilled.match(resultAction)) {
      message.success('Device IPs have been banned');
      dispatch(fetchBannedIps({ active: 'true' }));
    }
  }

  const deviceIps = device ? [device.ip, device.last_ip, device.create_ip].filter(Boolean) as string[] : [];
  const uniqueIps = Array.from(new Set(deviceIps));

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-device'>
        <h6 className="v-content-label">Block Device</h6>

        <div className='v-mb-20'>{<Meta device={device} about={true} />}</div>

        <div className='v-mb-20'>
          {
            device?.banned &&
              <RowInfo
                left={
                  <>
                    Banned Until: <u>{formattedDate(device?.banned_until).dateTime}</u>
                  </>
                }
                right={<Button onClick={() => onClickUnBlock('ban')} title='Remove Ban' icon={CheckCircleOutlined} />}
              />
          }
        </div>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <FormBlock params={{ period: 1, duration: 'days', type: 'ban' }} onFinish={onFinish} />

        <Divider />

        <h6 className="v-content-label">Ban IP</h6>
        {uniqueIps.length > 0 && (
          <div className='v-mb-10'>
            {uniqueIps.map(ip => <Tag key={ip}>{ip}</Tag>)}
          </div>
        )}

        <Form
          form={banIpForm}
          onFinish={onBanIp}
          layout="vertical"
          className='v-form'
          initialValues={{ reason: `Banned via device block #${device?.id}` }}
        >
          <Form.Item name='reason' label="Reason">
            <Input.TextArea placeholder='Ban reason' rows={2} />
          </Form.Item>

          <Form.Item>
            <ButtonAnt
              type="primary"
              htmlType="submit"
              loading={banIpLoading}
              icon={<StopOutlined />}
              style={{ width: '100%' }}
              className="v-btn v-btn-primary"
              disabled={uniqueIps.length === 0}
            >
              Ban All Device IPs
            </ButtonAnt>
          </Form.Item>
        </Form>

        <Divider />

        <ButtonAnt className="v-btn v-btn-primary" onClick={onClose} style={{ width: '100%' }}>
          Close
        </ButtonAnt>
      </div>
    </DrawerRight>
  )
}

export default Block;
